import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiConfirmationGetFileQueryResponse,
  GetApiConfirmationGetFileQueryParams,
  GetApiConfirmationGetFile401,
  GetApiConfirmationGetFile403,
} from "../../../types/GetApiConfirmationGetFile";

export function getGetApiConfirmationGetFileUrl() {
  return `/api/Confirmation/get-file` as const;
}

/**
 * {@link /api/Confirmation/get-file}
 */
export async function getApiConfirmationGetFile(
  params?: GetApiConfirmationGetFileQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiConfirmationGetFileQueryResponse,
    ResponseErrorConfig<
      GetApiConfirmationGetFile401 | GetApiConfirmationGetFile403
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiConfirmationGetFileUrl().toString(),
    params,
    ...requestConfig,
  });
  return res;
}
